import { INotification, IFooter } from 'src/models/util.model';
import services from 'src/services/util.service';
import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';

export const actionTypes = {
  FOOTER_FETCH: 'FOOTER_FETCH',
  NOTIFICATION_FETCH: 'NOTIFICATION_FETCH',
} as const;

export const asyncActions = {
  footerGET: {
    type: actionTypes.FOOTER_FETCH,
    service: services.footerGET,
    meta: {
      error: false,
    },
  },
  notifGET: {
    type: actionTypes.NOTIFICATION_FETCH,
    service: services.notifGET,
    meta: {
      error: false,
    },
  },
};

export type IUtilAsync = typeof asyncActions;

export interface IUtilState extends ICommonState<IUtilAsync> {
  footer: IFooter;
  notification: INotification;
}

export const defaultState: IUtilState = {
  status: {},
  footer: {},
  notification: {},
};

const UtilReducer = (
  state: IUtilState = defaultState,
  action: IReducerAction<IUtilAsync>
): IUtilState => {
  switch (action.type) {
    case actionTypes.FOOTER_FETCH: {
      return {
        ...state,
        footer: action.payload ?? {},
      };
    }
    case actionTypes.NOTIFICATION_FETCH: {
      return {
        ...state,
        notification: action.payload ?? {},
      };
    }
    default: {
      return state;
    }
  }
};

export default UtilReducer;
